import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {Template} from '../../../shared/interface/template';
import {ActivatedRoute} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {takeUntil} from 'rxjs/operators';
import {HttpErrorResponse} from '@angular/common/http';
import {TemplateService} from '../../../shared/services/template.service';

@Component({
  selector: 'app-template-details',
  templateUrl: './template-details.component.html',
  styleUrls: ['./template-details.component.scss']
})
export class TemplateDetailsComponent implements OnInit, OnDestroy {
  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  templateId: string;
  templateObject?: Template;
  template: ReplaySubject<Template> = new ReplaySubject<Template>(1);
  modify = false;

  constructor(
    private route: ActivatedRoute,
    private templateService: TemplateService,
    private snack: MatSnackBar,
  ) {
  }

  ngOnInit(): void {
    this.route.params
      .pipe(takeUntil(this.destroyed$))
      .subscribe(params => {
        this.templateId = params.id;
        this.loadTemplate();
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  loadTemplate(): void {
    this.templateService.get(this.templateId).subscribe((template: Template) => {
      this.template.next(template);
      this.templateObject = template;
    }, (error: HttpErrorResponse) => {
      this.snack.open('Nie udało się pobrać danych szablonu', error.status.toString(), {
        duration: 2000
      });
    });
  }
}
